<template>
  <div
    v-if="!disabled"
    :class="[`simple-radio-${appearance}`]"
    class="simple-radio-container"
  >
    <label
      :style="labelStyle"
      :class="{'simple-radio-label--reverse': reverse,
               'simple-radio-label--space-between': spaceBetween}"
      class="simple-radio-label"
    >
      <input
        v-model="checked"
        :value="value"
        :style="spaceBetween && { display: 'none' }"
        :disabled="readonly"
        type="radio"
      >
      <span class="simple-radio-checkmark" />
      <span
        v-if="label"
        class="simple-radio-text"
      >{{ label }}</span>
      <slot v-else>
        <i
          :class="[`icon-${icon}`]"
          class="simple-radio-icon icon"
        />
      </slot>
    </label>
  </div>
</template>

<script>
// Vue 3: opzione `model` rimossa. Prop `model` mantenuto; si emette `update:model`
// (per `v-model:model`) oltre a `change`.
export default {
  name: 'SimpleRadio',
  props: {
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }, 
    value: { type: String, required: true },
    model: { type: String, default: null },
    label: { type: String, default: null },
    icon: { type: String, default: null },
    reverse: { type: Boolean, default: false },
    appearance: {
      type: String,
      default: 'primary',
      validator: val => ['primary', 'secondary'].includes(val),
    },
    labelPadding: { type: String, default: null },
    color: { type: String, default: null },
    size: { type: Number, default: 13 },
    spaceBetween: { type: Boolean, default: false },
  },
  emits: ['update:model', 'change'],
  computed: {
    checked: {
      get() {
        return this.model;
      },
      set(newValue) {
        this.$emit('update:model', newValue);
        this.$emit('change', newValue);
      },
    },
    labelStyle() {
      return Object.assign(
        {
          fontSize: `${this.size}px`,
        },
        this.color && { color: this.color },
      );
    },
  },
};
</script>

<style lang="scss">

.simple-radio-container {
  display: flex;
  align-items: center;

  &.simple-radio-primary {
    input:checked ~ .simple-radio-checkmark {
      border: 5px solid $blue-sky;
      border-radius: 50%;
    }
  }

  &.simple-radio-secondary {
    input:checked ~ .simple-radio-checkmark {
      background-color: transparent;
      border: none;
    }

    .simple-radio-label input:checked ~ .simple-radio-checkmark:after {
      content: '';
      position: absolute;
      width: 11px;
      height: 2px;
      top: 50%;
      left: 37%;
      background-color: $white;
      transform: rotate(-45deg);
      border-radius: 2px;
    }

    .simple-radio-label input:checked ~ .simple-radio-checkmark:before {
      content: '';
      position: absolute;
      width: 2px;
      height: 7px;
      top: 41%;
      left: 28%;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      border-radius: 2px;
      background-color: $white;
    }

  }

  .simple-radio-label {
    display: flex;
    position: relative;
    cursor: pointer;
    font-size: $size-10;
    user-select: none;
    color: $blue-east-bay;
    height: 22px;
    align-items: center;

    &--reverse {
      flex-direction: row-reverse;
      .simple-radio-text {
        margin-right: 0.5rem;
      }
      .simple-radio-icon {
        margin-right: 0.5rem;
      }
    }

    &--space-between {
      width: 100%;
      justify-content: space-between;
    }

    input {
      position: relative;
      cursor: pointer;
      opacity: 0;
      height: 0;
      width: 0;
    }

    .simple-radio-checkmark {
      position: relative;
      top: 0;
      left: 0;
      height: 22px;
      width: 22px;
      background-color: $white-old;
      border-radius: 50%;
      border: 1px solid $grey-border-dark;
    }


    .simple-radio-checkmark:after {
      content: "";
      position: relative;
      display: none;
    }

    input:checked ~ .simple-radio-checkmark:after {
      display: block;
    }

    .simple-radio-text {
      margin-left: 0.5rem;
    }
    .simple-radio-icon {
      margin-left: 0.5rem;
    }
  }


}


</style>
